'use strict';

exports.druidResponseErrorHandler = druidResponseErrorHandler;

function druidResponseErrorHandler(context, config, next) {
  var responseError = {};
  next(responseError);
}